module.exports = __webpack_public_path__ + "static/media/google-play.af0c5354.svg";